import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import categories from 'src/app/data/categories';
import { ShopServiceService } from 'src/app/services/shop-service.service';

@Component({
  selector: 'app-store-add',
  templateUrl: './store-add.page.html',
  styleUrls: ['./store-add.page.scss'],
})
export class StoreAddPage implements OnInit {
  storeID;
  uploadForm: FormGroup;

  btnClicked = false;
  categories = categories;

  constructor(
    private formBuilder: FormBuilder,
    private shopService: ShopServiceService,
    private auth: AngularFireAuth
  ) {}

  ngOnInit() {
    this.uploadForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      category: ['', [Validators.required]],
      price: ['', [Validators.required]],
      description: ['', [Validators.required]],
    });
  }

  addProduct() {
    const details = this.uploadForm.value;
    this.auth.authState.pipe(take(1)).subscribe((user) => {
      if (user) {
        const userID = user.uid;
        this.shopService
          .getShopProfile(userID)
          .pipe(take(1))
          .subscribe((res: any) => {
            if (res.exists) {
              const data = res.data();
              console.log(data);
              const storeID = data.storeID;
              const productObject = {
                ...details,
                storeID,
              };

              console.log(productObject);
            } else {
              alert('Complete store profile first!');
            }
          });
      }
    });
  }
}
